/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import useScrollbarDisabled from './hooks/useScrollbarDisabled';

import ToolIcon from '../../assets/icons/tool.svg';
import CarIcon from '../../assets/icons/car.svg';

import GaragesAllocationWrapper from './sections/garages/wrapper';
import GarageFocusAllocationWrapper from './sections/garageFocus/wrapper';
import DriversAllocationWrapper from './sections/drivers/wrapper';

const Allocations = () => {
  const [tab, setTab] = useState('garages');
  document.title = 'Allocations';
  useScrollbarDisabled();

  return (
    <div>
      <div className="allocations-header">
        <div className="allocations-title"> Allocations </div>
        <div className="allocations-tabs">
          <div
            className={`allocations-tab ${tab === 'garages' && 'active'}`}
            onClick={() => setTab('garages')}
          >
            <ToolIcon /> Garages{' '}
          </div>
          <div
            className={`allocations-tab ${tab === 'garage-focus' && 'active'}`}
            onClick={() => setTab('garage-focus')}
          >
            <ToolIcon /> Garage Focus{' '}
          </div>
          <div
            className={`allocations-tab ${tab === 'drivers' && 'active'}`}
            onClick={() => setTab('drivers')}
          >
            <CarIcon /> Drivers{' '}
          </div>
        </div>
      </div>

      {tab === 'garages' && <GaragesAllocationWrapper />}
      {tab === 'garage-focus' && <GarageFocusAllocationWrapper />}
      {tab === 'drivers' && <DriversAllocationWrapper />}
    </div>
  );
};

export default Allocations;
